import prepareTableColumnOptions from '@/utils/prepareTableColumnOptions';

export const COMMISSION_PLAN_TABLE_NAME = 'commissionPlans';

// The columns available to be shown in a commissionPlans table.
export const COMMISSION_PLAN_TABLE_COLUMNS = {
  name: { label: 'Plan', key: 'name', sortable: true },
  rates_by_year: { label: 'Rates', key: 'rates_by_year' },
  user_id: { label: 'User', key: 'user_id', sortable: true },
  active: { label: 'Active', key: 'active' },
  actions: { label: 'Actions', key: 'actions' },
};

// The columns available to be selected in a form that is compatible
// with vue-select and bootstrap-vue selects.
export const COMMISSION_PLAN_TABLE_COLUMN_OPTIONS = prepareTableColumnOptions(COMMISSION_PLAN_TABLE_COLUMNS);
// The default columns to be shown when the commissionPlans table loads.
export const COMMISSION_PLAN_TABLE_DEFAULT_COLUMNS = [
  COMMISSION_PLAN_TABLE_COLUMNS.name,
  COMMISSION_PLAN_TABLE_COLUMNS.user_id,
  COMMISSION_PLAN_TABLE_COLUMNS.rates_by_year,
  COMMISSION_PLAN_TABLE_COLUMNS.actions,
];
